import { useEffect, useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { SimpleLinkField } from 'framework/ViewTypes';
import { PEOPLE_MANAGEMENT_POSITION_PROFILE_READ, POSITION_PROFILES_PATH } from '../../constants';
import usePositionProfilesService from '../../usePositionProfilesService';

type PositionProfileLinkFieldProps = {
  positionProfileId: string;
  defaultName: string;
};

const PositionProfileLinkField = ({ positionProfileId, defaultName }: PositionProfileLinkFieldProps) => {
  const { isGranted } = useAuthorization();
  const { getNameById } = usePositionProfilesService();
  const canReadPositionProfile = isGranted(PEOPLE_MANAGEMENT_POSITION_PROFILE_READ);
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    let isActive = true;

    setName(defaultName);

    if (canReadPositionProfile) {
      getNameById(positionProfileId)
        .then(positionProfileName => {
          if (isActive && positionProfileName) {
            setName(positionProfileName);
          }
        })
        .catch(() => undefined);
    }

    return () => {
      isActive = false;
    };
    // getNameById is recreated by the service hook and must not restart this request on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canReadPositionProfile, defaultName, positionProfileId]);

  if (!canReadPositionProfile) {
    return <>{defaultName}</>;
  }

  return <SimpleLinkField to={`${POSITION_PROFILES_PATH}/${positionProfileId}`} value={name} />;
};

export default PositionProfileLinkField;
